import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-business-logo',
  imports: [CommonModule],
  templateUrl: './business-logo.html',
  styleUrl: './business-logo.scss',
})
export class BusinessLogo {
  logoUrl = input.required<string>();
  name = input.required<string>();
  logoSize = input<string>('base');

  // Validar si el logo no se puede renderizar, en ese caso mostrar logo "?"" default
  hasLogoError = false;

  private lastValidLogo: string | null = null;

  handleImageError() {
    this.hasLogoError = true;
  }

  safeLogoUrl() {
    const url = this.logoUrl();

    if (!url || this.hasLogoError) {
      return this.lastValidLogo;
    }

    this.lastValidLogo = url;
    return url;
  }
}
